import React from "react";
import { useNavigate } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '150vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#000000',
      backgroundImage: 'radial-gradient(circle 400px at center 80%, rgba(53, 209, 254, 0.3) 0%, rgba(0, 0, 0, 1) 80%)',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      padding: '2rem',
      position: 'relative'
    }}>
      <div style={{
        position: 'absolute',
        top: '2rem',
        left: '2rem',
        zIndex: 10
      }}>
        <a href="/">
          <img
            src="/json-media/img/logo.svg"
            alt="GI"
            width={50}
            style={{ padding: 5 }}
          />
        </a>
      </div>

      <div style={{
        maxWidth: '800px',
        width: '100%',
        textAlign: 'center',
        position: 'relative',
        zIndex: 2
      }}>
        <div>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '1rem',
            marginBottom: '2rem'
          }}>
            <span style={{
              fontSize: '4rem',
              fontWeight: '700',
              color: '#ffffff',
              lineHeight: '1'
            }}>404</span>
          </div>

          <h1 style={{
            color: '#ffffff',
            fontSize: '2rem',
            fontWeight: '600',
            margin: '0 0 1rem 0',
            letterSpacing: '-0.025em'
          }}>
            Page Not Found
          </h1>

          <p style={{
            color: '#94a3b8',
            fontSize: '1.125rem',
            lineHeight: '1.6',
            margin: '0 0 2.5rem 0'
          }}>
            Sorry, the page you're looking for doesn't exist or has been moved.
          </p>

          <div style={{
            display: 'flex',
            gap: '1rem',
            justifyContent: 'center',
            flexWrap: 'wrap',
            marginBottom: '2.5rem'
          }}>
            <button
              onClick={() => navigate(-1)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                padding: '0.875rem 2rem',
                background: 'transparent',
                border: '1px solid rgba(255, 255, 255, 0.3)',
                borderRadius: '24px',
                color: '#ffffff',
                fontSize: '1rem',
                fontWeight: '500',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'rgba(37, 99, 235, 0.2)';
                e.target.style.borderColor = '#2563eb';
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 4px 20px rgba(37, 99, 235, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'transparent';
                e.target.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = 'none';
              }}
            >
              <ArrowLeft size={20} />
              Go Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;